module.exports = __webpack_public_path__ + "img/nb-1.42aa9a62.png";